export const userTypeMap = {
  investee: "dff-investee",
  investor: "dff-investor",
  intermediary: "dff-intermediary",
};
